<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="program_breadcrumb" />
    </div>
    <div class="header">
      <h1 class="overlay">PROGRAM INFORMATION</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>
    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">{{ $t('fisherman_title') }}</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">{{ $t('fisherman_subtitle') }}</div>
        <div class="rowSpace"></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
          <router-link
            v-show="isLang === 0"
            :to="{name: 'Realtimebooking2', params: {initProgramCode: 'P011'}}"
            class="resserve-button"
          >
            {{ $t('reserve_button') }}
          </router-link>
          <!--          <router-link to="/p/Reservpleisure/4" class="resserve-button"> 예약신청 </router-link>-->
        </div>
        <div class="rowSpace"><hr /></div>
        <GallerySlideCarousels :slides="main_slides" :slide-count="3" :thumb-slide-width="60" />
      </div>
    </div>
    <div class="container subContainer">
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 mainInfo">
          <div>{{ $t('fisherman_desc1') }}</div>
          <div>{{ $t('fisherman_desc2') }}</div>
          <div>{{ $t('fisherman_desc3') }}</div>
          <div>{{ $t('fisherman_desc4') }}</div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('fisherman_common_title') }}</div>
          <div class="subDatail">
            <div>{{ $t('fisherman_common_desc1') }}</div>
            <div>{{ $t('fisherman_common_desc2') }}</div>
            <div>{{ $t('fisherman_common_desc3') }}</div>
            <!--            <div>{{ $t('fisherman_common_desc4') }}</div>-->
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('fisherman_main_title') }}</div>
          <div class="row d-flex">
            <div v-for="(item, index) in sub_items" :key="index" class="col-lg-4 col-12 mb-4">
              <template>
                <div class="card">
                  <a :href="item.href">
                    <img class="card-img-top" :src="item.image" alt="Card image cap" style="padding: 10px"
                  /></a>
                  <div class="card-body">
                    <h5 class="card-title" style="letter-spacing: -0.02rem">{{ $t(item.title) }}</h5>
                    <p class="card-text" style="font-size: 0.8rem; word-break: keep-all; height: 5rem">
                      {{ $t(item.desc) }}
                    </p>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <!--          <div class="subDatail">-->
          <!--            <div>1. 뱅에돔낚시 : 하효항 출발</div>-->
          <!--            <div>2. 제철낚시 : 사계항 출발</div>-->
          <!--          </div>-->
          <div class="rowSpace"></div>

          <table class="web table table-bordered subTable">
            <thead>
              <tr>
                <td>{{ $t('fisherman_table1_tr1_td1') }}</td>
                <td>{{ $t('fisherman_table1_tr1_td2') }}</td>
                <td>{{ $t('fisherman_table1_tr1_td3') }}</td>
                <td>{{ $t('fisherman_table1_tr1_td4') }}</td>
                <td>{{ $t('fisherman_table1_tr1_td5') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('fisherman_table1_tr2_td1') }}</td>
                <td rowspan="2">{{ $t('fisherman_table1_tr2_td2') }}</td>
                <td>{{ $t('fisherman_table1_tr2_td3') }}</td>
                <td>{{ $t('fisherman_table1_tr2_td4') }}</td>
                <td rowspan="2">{{ $t('fisherman_table1_tr2_td5') }}</td>
              </tr>
              <tr>
                <td>{{ $t('fisherman_table1_tr3_td1') }}</td>
                <td>{{ $t('fisherman_table1_tr3_td2') }}</td>
                <td>{{ $t('fisherman_table1_tr3_td3') }}</td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td class="subTable2">{{ $t('fisherman_table1_tr1_td1') }}</td>
                <td>{{ $t('fisherman_table1_tr2_td1') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('fisherman_table1_tr2_td2') }}</td>
                <td>{{ $t('fisherman_table1_tr1_td2') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('fisherman_table1_tr1_td3') }}</td>
                <td>{{ $t('fisherman_table1_tr2_td3') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('fisherman_table1_tr1_td4') }}</td>
                <td>{{ $t('fisherman_table1_tr2_td4') }}</td>
              </tr>
              <tr>
                <td class="subTable3">{{ $t('fisherman_table1_tr1_td5') }}</td>
                <td>{{ $t('fisherman_table1_tr2_td5') }}</td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td class="subTable2">{{ $t('fisherman_table1_tr1_td1') }}</td>
                <td>{{ $t('fisherman_table1_tr3_td1') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('fisherman_table1_tr2_td2') }}</td>
                <td>{{ $t('fisherman_table1_tr1_td2') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('fisherman_table1_tr1_td3') }}</td>
                <td>{{ $t('fisherman_table1_tr3_td2') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('fisherman_table1_tr1_td4') }}</td>
                <td>{{ $t('fisherman_table1_tr3_td3') }}</td>
              </tr>
              <tr>
                <td class="subTable3">{{ $t('fisherman_table1_tr1_td5') }}</td>
                <td>{{ $t('fisherman_table1_tr2_td5') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="rowSpace"><hr /></div>
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('fisherman_addition_title') }}</div>

          <GallerySlideCarousels :slides="addition_slides" :slide-count="4" :thumb-slide-width="50" />

          <table class="col-lg-12 table table-bordered subTable">
            <thead>
              <tr>
                <td>{{ $t('fisherman_table2_tr1_td1') }}</td>
                <td colspan="2">{{ $t('fisherman_table2_tr1_td2') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('fisherman_table2_tr2_td1') }}</td>
                <td>{{ $t('fisherman_table2_tr2_td2') }}</td>
                <td rowspan="5">{{ $t('fisherman_table2_tr2_td3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('fisherman_table2_tr3_td1') }}</td>
                <td>{{ $t('fisherman_table2_tr3_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('fisherman_table2_tr4_td1') }}</td>
                <td>{{ $t('fisherman_table2_tr4_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('fisherman_table2_tr5_td1') }}</td>
                <td>{{ $t('fisherman_table2_tr5_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('fisherman_table2_tr6_td1') }}</td>
                <td>{{ $t('fisherman_table2_tr6_td2') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('fisherman_etc_title') }}</div>
          <div class="subDetail">
            <div>{{ $t('fisherman_etc_desc1') }}</div>
            <div>{{ $t('fisherman_etc_desc2') }}</div>
            <div>{{ $t('fisherman_etc_desc3') }}</div>
            <div>{{ $t('fisherman_etc_desc4') }}</div>
            <div>{{ $t('fisherman_etc_desc5') }}</div>
            <div>{{ $t('fisherman_etc_desc6') }}</div>
            <div>{{ $t('fisherman_etc_desc7') }}</div>
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
          <router-link
            v-show="isLang === 0"
            :to="{name: 'Realtimebooking2', params: {initProgramCode: 'P011'}}"
            class="resserve-button"
          >
            {{ $t('reserve_button') }}
          </router-link>
          <!--          <router-link to="/p/Reservpleisure/4" class="resserve-button"> 예약신청 </router-link>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';

export default {
  name: 'jejufisherman',
  data() {
    return {
      isLang: 0,
      program_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      },
      main_slides: [
        {image: require('@/assets/images/pleisure/program/jejufisherman_main_01.jpg')},
        {image: require('@/assets/images/pleisure/program/jejufisherman_main_02.jpg')},
        {image: require('@/assets/images/pleisure/program/jejufisherman_main_03.jpg')},
      ],
      addition_slides: [
        {image: require('@/assets/images/pleisure/program/jejufisherman_option_01.jpg')},
        {image: require('@/assets/images/pleisure/program/jejufisherman_option_02.jpg')},
        {image: require('@/assets/images/pleisure/program/jejufisherman_option_03.jpg')},
        {image: require('@/assets/images/pleisure/program/vonestis_option_01.jpg')},
      ],
      sub_items: [
        {
          title: 'fisherman_mainp_title1',
          desc: 'fisherman_mainp_desc1',
          image: require('@/assets/images/pleisure/program/jejufisherman_main_02.jpg'),
        },
        {
          title: 'fisherman_mainp_title2',
          desc: 'fisherman_mainp_desc2',
          image: require('@/assets/images/pleisure/program/jejufisherman_main_01.jpg'),
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  components: {Breadcrumb, GallerySlideCarousels},
};
</script>

<style scoped lang="scss">
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
td {
  vertical-align: middle;
}
.top {
  padding-top: 11rem;
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  > div {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      text-align: center;
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
      word-break: keep-all;
    }
  }
}

.subTable2 {
  font-weight: bold;
}
.subTable3 {
  background-color: #f3f3f3;
  font-weight: bold;
}

.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}

.headerimage {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/pleisure/program/jejufisherman_headerimage.jpg');
}

@media (min-width: 992px) {
  .web {
  }

  .mobile {
    display: none;
  }
}

@media (max-width: 992px) {
  .headerimage {
    display: none;
  }

  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }

  .web {
    display: none;
  }

  .mobile {
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "프로그램 안내",
    "fisherman_title": "제주어부",
    "fisherman_subtitle": "제주 바다를 고스란히 느끼는 익스트림 액티비티",
    "prev_button": "이전",
    "reserve_button": "예약신청",
    "fisherman_desc1": "지루한 일상에 새로운 활력을 줄 수 있는 대표적인 스포츠 액티비티 입니다.",
    "fisherman_desc2": "실제 배를 타고 나가 바다에서 낚시를 체험할 수 있는 상품이며, 독배로 운영되어 프라이빗하게 지인들과의 즐거운 시간을 보낼 수 있습니다.",
    "fisherman_desc3": "제주에서만 만날 수 있는 어종들을 낚시하고, 즉석회까지 즐겨보는 특별한 추억을 만들어 보세요.",
    "fisherman_desc4": "※ 연령제한 14세 이상",
    "fisherman_common_title": "공통 의전 및 서비스",
    "fisherman_common_desc1": "- 차량 의전 서비스 (벤츠 스프린터 / 카니발 하이리무진)",
    "fisherman_common_desc2": "- 핀크스 의전 담당 매니저 케어",
    "fisherman_common_desc3": "- 어메니티, 미니바 제공",
    "fisherman_common_desc4": "- F&B 세트 제공",
    "fisherman_main_title": "메인 프로그램",
    "fisherman_mainp_title1": "뱅에돔낚시",
    "fisherman_mainp_desc1": "하효항 출발",
    "fisherman_mainp_title2": "제철낚시",
    "fisherman_mainp_desc2": "사계항 출발",
    "fisherman_table1_tr1_td1": "옵션",
    "fisherman_table1_tr1_td2": "최대인원",
    "fisherman_table1_tr1_td3": "소요시간",
    "fisherman_table1_tr1_td4": "요금(2인기준)",
    "fisherman_table1_tr1_td5": "추가옵션",
    "fisherman_table1_tr2_td1": "벵어돔 낚시",
    "fisherman_table1_tr2_td2": "10인",
    "fisherman_table1_tr2_td3": "1 day",
    "fisherman_table1_tr2_td4": "1,500,000",
    "fisherman_table1_tr2_td5": "※ 인원추가 +100,000 원 / 인",
    "fisherman_table1_tr3_td1": "제철낚시",
    "fisherman_table1_tr3_td2": "1 day",
    "fisherman_table1_tr3_td3": "1,400,000",
    "fisherman_addition_title": "추가옵션",
    "fisherman_table2_tr1_td1": "구분",
    "fisherman_table2_tr1_td2": "옵션(2인기준)",
    "fisherman_table2_tr2_td1": "150,000",
    "fisherman_table2_tr2_td2": "수테라피, 사격, 오모로비짜 스파(40분)",
    "fisherman_table2_tr2_td3": "※ 3인 이상 시 전화 문의",
    "fisherman_table2_tr3_td1": "200,000",
    "fisherman_table2_tr3_td2": "메디컬 스파(바디)",
    "fisherman_table2_tr4_td1": "350,000",
    "fisherman_table2_tr4_td2": "오모로비짜 스파(90분)",
    "fisherman_table2_tr5_td1": "400,000",
    "fisherman_table2_tr5_td2": "본에스티스 스파(90분)",
    "fisherman_table2_tr6_td1": "플라워 세팅",
    "fisherman_table2_tr6_td2": "300,000 / 500,000 / 700,000",
    "fisherman_etc_title": "기타사항",
    "fisherman_etc_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "fisherman_etc_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "fisherman_etc_desc3": "※ 단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.",
    "fisherman_etc_desc4": "- 7일 전 위약금 0%, 6일 전 ~ 5일 전 30%, 4일 전 50%, 3일 전~2일 전(~17시) 70%, 2일전(17시~) ~ 당일 100% 위약금 부과",
    "fisherman_etc_desc5": "※ 천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "fisherman_etc_desc6": "※ 여행자보험 포함 상품입니다.",
    "fisherman_etc_desc7": "※ 요금표 외 기타 인원은 전화 문의"
  },
  "en": {
    "breadcrumb": "Program Information",
    "fisherman_title": "Jeju Fisherman",
    "fisherman_subtitle": "Extreme activity to feel pure Jeju Sea.",
    "prev_button": "Previous",
    "reserve_button": "Book Now",
    "fisherman_desc1": "A signature sports activity to vitalize your daily lives.",
    "fisherman_desc2": "You can go out by boat and experience fishing in the sea, and enjoy a private time as you can solely use the boat.",
    "fisherman_desc3": "Experience fishing Jeju native fishes and make special memories of tasting a freshly sliced raw fish.",
    "fisherman_desc4": "※ Available only for 14 years old or older",
    "fisherman_common_title": "Common escort service and other services",
    "fisherman_common_desc1": "- Escort vehicle service (Benz Sprinter / Carnival High Limousine)",
    "fisherman_common_desc2": "- Care service by the PINX escort manager",
    "fisherman_common_desc3": "- Free amenities and minibar",
    "fisherman_common_desc4": "- Complimentary F&B sets",
    "fisherman_main_title": "Main Program",
    "fisherman_mainp_title1": "Fishing Opaleye",
    "fisherman_mainp_desc1": "Depart from Hahyohang Port",
    "fisherman_mainp_title2": "Seasonal fishing",
    "fisherman_mainp_desc2": "Depart from Sagyehang Port",
    "fisherman_table1_tr1_td1": "Option",
    "fisherman_table1_tr1_td2": "Maximum Occupancy",
    "fisherman_table1_tr1_td3": "Total Time",
    "fisherman_table1_tr1_td4": "Fare(2 people)",
    "fisherman_table1_tr1_td5": "Additional option",
    "fisherman_table1_tr2_td1": "Fishing Opaleye",
    "fisherman_table1_tr2_td2": "10 People",
    "fisherman_table1_tr2_td3": "1 day",
    "fisherman_table1_tr2_td4": "KRW 1,500,000",
    "fisherman_table1_tr2_td5": "※ Additional person + KRW 100,000 / 1 person",
    "fisherman_table1_tr3_td1": "Seasonal fishing",
    "fisherman_table1_tr3_td2": "1 day",
    "fisherman_table1_tr3_td3": "KRW 1,400,000",
    "fisherman_addition_title": "Additional Options",
    "fisherman_table2_tr1_td1": "Fare",
    "fisherman_table2_tr1_td2": "Option(2 person)",
    "fisherman_table2_tr2_td1": "KRW 150,000",
    "fisherman_table2_tr2_td2": "Water therapy, Shooting, Omorovicza Spa(40min.)",
    "fisherman_table2_tr2_td3": "※ More than 3 people, please contact us",
    "fisherman_table2_tr3_td1": "KRW 200,000",
    "fisherman_table2_tr3_td2": "Medical Spa(Body)",
    "fisherman_table2_tr4_td1": "KRW 350,000",
    "fisherman_table2_tr4_td2": "Omoroicza Spa(90 min.)",
    "fisherman_table2_tr5_td1": "KRW 400,000",
    "fisherman_table2_tr5_td2": "Vonestis Spa(90 min.)",
    "fisherman_table2_tr6_td1": "Flower Service",
    "fisherman_table2_tr6_td2": "KRW 300,000 / 500,000 / 700,000",
    "fisherman_etc_title": "Others",
    "fisherman_etc_desc1": "※ A fare applies for children aged 5 or older.",
    "fisherman_etc_desc2": "※ In some cases, minors may need a guardian.",
    "fisherman_etc_desc3": "※ The company’s cancellation policy shall apply in the case of cancellation or refund due to a simple change in mind.",
    "fisherman_etc_desc4": "- Penalty will be charged 0% until 7 days prior to the reserved date, 30% from 5 to 6 days before, 50% until 4 days before, 70% until 2 to 3 days before (by 5pm), and no refund will be made(100% penalty) after 5pm 2 days prior to the reserved date.",
    "fisherman_etc_desc5": "※ In case of cancellation due to natural disasters or unavoidable circumstances due to the company's operational reason, the cancellation policy shall not apply.",
    "fisherman_etc_desc6": "※ Traveler's insurance is included in the product.",
    "fisherman_etc_desc7": "※ Contact us by phone for the group of people other than the number in the price list."
  },
  "ja": {
    "breadcrumb": "프로그램 안내",
    "fisherman_title": "제주어부",
    "fisherman_subtitle": "제주 바다를 고스란히 느끼는 익스트림 액티비티",
    "prev_button": "이전",
    "reserve_button": "예약신청",
    "fisherman_desc1": "지루한 일상에 새로운 활력을 줄 수 있는 대표적인 스포츠 액티비티 입니다.",
    "fisherman_desc2": "실제 배를 타고 나가 바다에서 낚시를 체험할 수 있는 상품이며, 독배로 운영되어 프라이빗하게 지인들과의 즐거운 시간을 보낼 수 있습니다.",
    "fisherman_desc3": "제주에서만 만날 수 있는 어종들을 낚시하고, 즉석회까지 즐겨보는 특별한 추억을 만들어 보세요.",
    "fisherman_desc4": "※ 연령제한 14세 이상",
    "fisherman_common_title": "공통 의전 및 서비스",
    "fisherman_common_desc1": "- 차량 의전 서비스 (벤츠 스프린터 / 카니발 하이리무진)",
    "fisherman_common_desc2": "- 핀크스 의전 담당 매니저 케어",
    "fisherman_common_desc3": "- 어메니티, 미니바 제공",
    "fisherman_common_desc4": "- F&B 세트 제공",
    "fisherman_main_title": "메인 프로그램",
    "fisherman_mainp_title1": "뱅에돔낚시",
    "fisherman_mainp_desc1": "하효항 출발",
    "fisherman_mainp_title2": "제철낚시",
    "fisherman_mainp_desc2": "사계항 출발",
    "fisherman_table1_tr1_td1": "옵션",
    "fisherman_table1_tr1_td2": "최대인원",
    "fisherman_table1_tr1_td3": "소요시간",
    "fisherman_table1_tr1_td4": "요금(2인기준)",
    "fisherman_table1_tr1_td5": "추가옵션",
    "fisherman_table1_tr2_td1": "벵어돔 낚시",
    "fisherman_table1_tr2_td2": "10인",
    "fisherman_table1_tr2_td3": "1 day",
    "fisherman_table1_tr2_td4": "1,500,000",
    "fisherman_table1_tr2_td5": "※ 인원추가 +100,000 원 / 인",
    "fisherman_table1_tr3_td1": "제철낚시",
    "fisherman_table1_tr3_td2": "1 day",
    "fisherman_table1_tr3_td3": "1,400,000",
    "fisherman_addition_title": "추가옵션",
    "fisherman_table2_tr1_td1": "구분",
    "fisherman_table2_tr1_td2": "옵션(2인기준)",
    "fisherman_table2_tr2_td1": "150,000",
    "fisherman_table2_tr2_td2": "수테라피, 사격, 오모로비짜 스파(40분)",
    "fisherman_table2_tr2_td3": "※ 3인 이상 시 전화 문의",
    "fisherman_table2_tr3_td1": "200,000",
    "fisherman_table2_tr3_td2": "메디컬 스파(바디)",
    "fisherman_table2_tr4_td1": "350,000",
    "fisherman_table2_tr4_td2": "오모로비짜 스파(90분)",
    "fisherman_table2_tr5_td1": "플라워 세팅",
    "fisherman_table2_tr5_td2": "300,000 / 500,000 / 700,000",
    "fisherman_etc_title": "기타사항",
    "fisherman_etc_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "fisherman_etc_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "fisherman_etc_desc3": "※ 단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.",
    "fisherman_etc_desc4": "- 7일 전 위약금 0%, 6일 전 ~ 5일 전 30%, 4일 전 50%, 3일 전~2일 전(~17시) 70%, 2일전(17시~) ~ 당일 100% 위약금 부과",
    "fisherman_etc_desc5": "※ 천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "fisherman_etc_desc6": "※ 여행자보험 포함 상품입니다.",
    "fisherman_etc_desc7": "※ 요금표 외 기타 인원은 전화 문의"
  }
}
</i18n>
